<template>
  <div class="home">
    <hero></hero>
    <cardSection @openModal="openModal($event)"></cardSection>
    <section class="section-cards">
      <formSection></formSection>
    </section>
    <div class="popup" v-if="openPopup">
      <popup :info="popupInfo" @closeModal="closeModal()"></popup>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from '../components/HeroSection/Hero';
import FormSection from '../components/FormSection/FormSection';
import CardSection from '../components/CardSection/Card';
import Popup from '../components/Reusable/PopUp';

export default {
  name: 'home',
  data() {
    return {
      openPopup: false,
      popupInfo: null
    };
  },
  components: {
    Hero,
    FormSection,
    CardSection,
    Popup
  },
  methods: {
    openModal(i) {
      this.openPopup = true;
      this.popupInfo = i;
    },
    closeModal() {
      this.openPopup = false;
      this.popupInfo = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.popup {
  position: relative;
}
.section-cards {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-around;
}
</style>
